import RouterHelper from '../../util/RouterHelper'
import StoreHelper from '../helper'
import PaginationHelper from '../../util/PaginationHelper'

import EventBus, { Events } from '../../event-bus'
import state from './state'
import _ from 'lodash'

const helper = {
  // setter
  setEditItem: (item) => {
    state.editItem = _.cloneDeep(item)
  },

  setHoverItem: (item) => {
    if (!StoreHelper.isHoverAllowed()) return

    state.hoverItem = _.cloneDeep(item)
  },

  setActiveView: (view) => {
    state.activeView = view
    EventBus.$emit(Events.B_MENU_ACTIVE_VIEW_CHANGED)
  },

  setPaginationPage (page) {
    state.pagination.page = page

    // TODO: Move to active view listener
    PaginationHelper.redefineElementsVisibility(StoreHelper.getDragElements(StoreHelper.getActiveViewKey()))
  },

  // getter
  getEditItem: () => {
    return _.get(state, 'editItem', null)
  },

  getHoverItem: () => {
    return _.get(state, 'hoverItem', null)
  },

  getActiveViewItems: () => {
    return _.get(state.activeView, 'children', [])
  },

  // rename method -> workingItem ???
  getActiveChild: () => {
    return helper.getEditItem() || helper.getHoverItem()
  },

  // TODO: Move to ViewManager ?
  getViews: () => {
    return _.get(state, 'views', {})
  },

  // getViewByKey
  getViewByPath: (path) => {
    return _.get(helper.getViews(), path, null)
  },

  getViewKey (component) {
    return _.findKey(helper.getViews(), component)
  },

  getActiveView: () => {
    return state.activeView
  },

  getActiveViewKey () {
    return helper.getViewKey(helper.getActiveView())
  },

  getActiveViewData: () => {
    return {
      parent: _.get(state.activeView, 'parent', null),
      children: _.get(state.activeView, 'items', null)
    }
  },

  getActiveViewPath: () => {
    return _.findKey(state.views, state.activeView)
  },

  getBreadcrumbHomeItem () {
    return { title: StoreHelper.getBreadcrumbHomeLabel(), path: '' }
  },

  getPaginationPage () {
    return state.pagination.page
  },

  // helper
  isHoverItem: (item) => {
    return ItemComparer.compareByProperty(state.hoverItem, item, 'identifier')
  },

  isHoverAllowed: () => {
    return !StoreHelper.isEditInProgress() && !StoreHelper.isDragInProgress()
  },

  isEditItem: (item) => {
    return ItemComparer.compareByProperty(state.editItem, item, 'identifier')
  },

  isHoverInProgress: () => {
    return StoreHelper.isHoverAllowed() && !_.isNull(state.hoverItem)
  },

  isEditInProgress: () => {
    return !_.isNull(state.editItem)
  },

  isHomeView: () => {
    return _.get(StoreHelper.getActiveView(), 'isHomeView', null)
  },

  registerView: (name, view) => {
    _.assign(state.views, _.fromPairs([[name, view]]))
  },

  canCreateView () {
    const currentItemsAmount = StoreHelper.getActiveViewItems().length
    return StoreHelper.isPaginationEnabled() || _.lt(currentItemsAmount, StoreHelper.getMaxItemsPerPage())
  },

  showBackNavigationBubble: () => {
    return !_.isEqual(StoreHelper.getActiveViewPath(), _.get(StoreHelper.getInitialRoute(), 'path'))
  },

  // Extract path
  navigateBack: () => {
    const currentRoute = RouterHelper.extractCurrentRoute(StoreHelper.getRouter())
    const parentRoutePath = RouterHelper.extractParentRoutePath(currentRoute)

    if (helper.getViewByPath(parentRoutePath)) {
      return RouterHelper.goTo(StoreHelper.getRouter(), { path: parentRoutePath })
    }

    return EventBus.$emit(Events.B_MENU_BACK_CLICKED, _.get(StoreHelper.getActiveViewData(), 'parent', null))
  }
}

class ItemComparer {
  static compareByProperty (a, b, property) {
    const propA = _.get(a, property, 'a')
    const propB = _.get(b, property, 'b')

    return _.isEqual(propA, propB)
  }
}

export default helper
